import {fromJsonObject, usingJsonToModelConvertor} from "../decorators";
import {Model} from "../Model";
import {Colors} from "../../../themes/baran/colors";

@usingJsonToModelConvertor
export default class OrderStage extends Model {

    @fromJsonObject({key: 'text'})
    public textStatus!: string;

    @fromJsonObject({key: 'general_status'})
    public generalStatus!: "normal"|"done"|"aborted";

    @fromJsonObject({key: 'stage_number'})
    public stageNumber!: 0|1|2|3|4|5|6|7;

    public getColor(colors: Colors):string{
        switch (this.generalStatus){
            case "normal":
                return colors.get("primaryColor") as string;
            case "done":
                return colors.get("green") as string;
            case "aborted":
                return colors.get("red") as string;
        }
    }

}
